<template>
  <div class="col-xl-12 col-lg-12">
    <el-table  :data="tableData" @current-change="selectRow" :row-style="rowStyle" v-loading="tableLoading" >
      <el-table-column prop="id" label="PEA No." width="120"></el-table-column>
      <el-table-column prop="urgency" label="Emergency" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.urgency">Yes</span>
          <span v-else>No</span>
        </template>
      </el-table-column>
      <el-table-column prop="capitalBudget" label="Capital Budget ID" width="130">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.capitalBudget" effect="light" :content="scope.row.capitalBudget" placement="right">
            <span>{{scope.row.capitalBudget}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="peaName" label="Name" width="140"></el-table-column>
      <el-table-column prop="createdDate" label="Created" width="150">
        <template slot-scope="props">
          {{ formatDate(props.row.createdDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" label="Raised By" width="130"></el-table-column>
      <el-table-column prop="costCenter" label="Cost Center" width="125">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.costCenter" effect="light" :content="scope.row.costCenter" placement="bottom">
            <span>{{scope.row.costCenter}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="peaDivision" label="Division" width="152"></el-table-column>
      <el-table-column prop="isSBU" label="Applicable SBU" width="131">
        <template slot-scope="scope">
          <span v-if="scope.row.isSBU">Yes</span>
          <span v-else>No</span>
        </template>
      </el-table-column>
      <el-table-column prop="peaDepartments" label="Departments" width="180">
        <template slot-scope="scope">
          <ul>
            <li v-for="department in scope.row.peaDepartments" v-bind:key="department.id">{{ department.name }}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column prop="peaStatus" label="Status" width="160">
        <template slot-scope="scope">
          <status-icon :statusId="scope.row.peaStatusId"></status-icon> {{ scope.row.peaStatus }}
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="Reason" width="150"></el-table-column>
      <el-table-column prop="netExpenditure" label="Cost" width="200">
        <template slot-scope="scope">
          $ {{ formatMoney(scope.row.netExpenditure)}}
        </template>
      </el-table-column>
    </el-table>
    <br/>
    <el-pagination v-if="resultTotalC > pageSizeC"
      @current-change="currentChange"
      :current-page.sync="pageC"
      :page-size="pageSizeC"
      layout="total, prev, pager, next"
      :total="resultTotalC"
      background>
    </el-pagination>
  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'

import router from '@/router'
export default {
  name: 'peaTable',
  props: {
    tableData: {
      default: null
    },
    page: {
      default: 1
    },
    pageSize: {
      default: 50
    },
    resultTotal: {
      default: 0
    },
    status: {
      default: 1
    },
    searchId: {
      default: 0
    },
    tableLoading: {
      default: false
    },
    selectRow: {
      default: null
    },
    rowStyle: {
      default: null
    },
    currentChange: {
      default: null
    }
  },
  computed: {
    pageC: {
      get: function () {
        return this.page
      },
      set: function (modifiedValue) {
        this.$parent.$emit('page', modifiedValue)
      }
    },
    pageSizeC: {
      get: function () {
        return this.pageSize
      },
      set: function (modifiedValue) {
        this.$parent.$emit('pageSize', modifiedValue)
      }
    },
    resultTotalC: {
      get: function () {
        return this.resultTotal
      },
      set: function (modifiedValue) {
        this.$parent.$emit('resultTotal', modifiedValue)
      }
    }
  },
  methods: {
    selectRowMethod: function (row) {
      router.push('/editPea/' + row.id)
    },
    rowStyleMethod () {
      return 'cursor: pointer;'
    },
    defaultChangeMethod: function () {
      return null
    },
    formatDate: function (entry) {
      return helperMethods.formatDate(entry)
    },
    formatMoney (number) {
      return helperMethods.formatMoney(number)
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  padding: 0;
}
</style>
